import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import css from "./EntityIcon.module.scss";

const EntityIcon = ({icon, small = false, className, style}) => (
  <i
    data-testid={"EntityList-EntityIcon"}
    className={classNames(css.graphIcon, `ph-${icon}`, className, {
      [css.smallIcon]: small
    })}
    {...{style}}></i>
);

EntityIcon.propTypes = {
  /** Entity Type to render Icon for */
  icon: PropTypes.string.isRequired,
  /** Optional className to append to icon element */
  className: PropTypes.string,
  /** Optional style props */
  style: PropTypes.object
};

export default EntityIcon;
